import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

const ChannelListContainer = styled.div<React.CSSProperties>`
  position: fixed;
  top: ${512 * Screen.widthRatio}px;
  transition: none;
`;

export default ChannelListContainer;
